// assets/v4p-professional-selector.js
(function () {
  const DEFAULTS = {
    workerUrl: null,
    pharmacyId: null,
    sessionKey: "v4p_staff_session",
  };

  function getSession(sessionKey) {
    try {
      const raw = sessionStorage.getItem(sessionKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function normalizeStr(v) {
    return (v || "").toString().trim();
  }

  function buildFullName(staff) {
    const fn = normalizeStr(staff.firstName);
    const sn = normalizeStr(staff.surname);
    if (fn || sn) return `${fn} ${sn}`.trim();
    return normalizeStr(staff.name) || normalizeStr(staff.username) || "Unknown";
  }

  function getRegistration(staff) {
    // Support a few possible key names
    const gphc = normalizeStr(staff.gphcNumber || staff.gphc || staff.gphc_no);
    const psni = normalizeStr(staff.psniNumber || staff.psni || staff.psni_no);
    const rcvs = normalizeStr(staff.rcvsNumber || staff.rcvs || staff.rcvs_no);

    if (gphc) return { body: "GPhC", number: gphc };
    if (psni) return { body: "PSNI", number: psni };
    if (rcvs) return { body: "RCVS", number: rcvs };
    return null;
  }

  function isRegistered(staff) {
    return !!getRegistration(staff);
  }

  async function fetchStaffList(workerUrl, pharmacyId) {
    const res = await fetch(`${workerUrl}/get-staff`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customerId: pharmacyId }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json?.error || "Failed to load staff list");
    return json?.staffData?.staff || [];
  }

  function createOptionUI(container) {
    container.innerHTML = `
        <div class="v4p-pro-selector">

        <div class="v4p-pro-selector__options v4p-toggle-options">
            <label class="v4p-toggle-option">
            <input type="radio" name="v4p_pro_mode" value="current">
            <span>Use my details</span>
            </label>

            <label class="v4p-toggle-option">
            <input type="radio" name="v4p_pro_mode" value="select">
            <span>Select registered staff</span>
            </label>

            <label class="v4p-toggle-option">
            <input type="radio" name="v4p_pro_mode" value="manual">
            <span>Enter manually</span>
            </label>
        </div>

        <div class="v4p-pro-selector__select" style="display:none; margin-top:10px;">
            <div class="v4p-form__group">
            <label class="v4p-form__label" for="v4p-pro-staff-dropdown">Registered staff</label>
            <select id="v4p-pro-staff-dropdown" class="v4p-form__select">
                <option value="">Select a registered staff member...</option>
            </select>
            </div>
        </div>

        <div id="v4p-pro-hint" class="v4p-form__hint" style="margin-top:8px;"></div>
        </div>
    `;

    return {
        radios: [...container.querySelectorAll('input[name="v4p_pro_mode"]')],
        selectWrap: container.querySelector(".v4p-pro-selector__select"),
        dropdown: container.querySelector("#v4p-pro-staff-dropdown"),
        hint: container.querySelector("#v4p-pro-hint"),
    };
    }


  // Public init
  window.V4PProfessionalSelector = async function initProfessionalSelector(opts) {
    const cfg = { ...DEFAULTS, ...opts };
    if (!cfg.workerUrl || !cfg.pharmacyId) throw new Error("Missing workerUrl or pharmacyId");
    if (!cfg.mountEl) throw new Error("Missing mountEl");
    if (!cfg.fields) throw new Error("Missing fields mapping");

    const session = getSession(cfg.sessionKey);

    const staff = await fetchStaffList(cfg.workerUrl, cfg.pharmacyId);

    // Find the logged-in staff member inside the staff list
    const sessionUsername = normalizeStr(session?.username).toLowerCase();
    const currentStaff = staff.find(s =>
    normalizeStr(s?.username).toLowerCase() === sessionUsername
    );

    // Current is registered ONLY if their staff record has a registration number
    const currentIsRegistered = !!currentStaff && isRegistered(currentStaff);

    const registeredStaff = staff
    .filter(s => s && s.active !== false)
    .filter(s => !s.hidden)
    .filter(isRegistered);


    const ui = createOptionUI(cfg.mountEl);

    // If current staff not registered, hide "current" option
    const currentRadioLabel = ui.radios.find(r => r.value === "current")?.closest("label");
    if (!currentIsRegistered && currentRadioLabel) currentRadioLabel.style.display = "none";

    // Populate dropdown
    registeredStaff.forEach((s, idx) => {
      const reg = getRegistration(s);
      const name = buildFullName(s);
      const opt = document.createElement("option");
      opt.value = String(idx);
      opt.textContent = `${name} — ${reg.body} ${reg.number}`;
      ui.dropdown.appendChild(opt);
    });

    function setForm(staffObj) {
      const reg = getRegistration(staffObj);

      const first = normalizeStr(staffObj.firstName) || (buildFullName(staffObj).split(" ")[0] || "");
      const last = normalizeStr(staffObj.surname) || (buildFullName(staffObj).split(" ").slice(1).join(" ") || "");

      // Unlock everything first
      unlockForm();

      if (cfg.fields.firstName) cfg.fields.firstName.value = first;
      if (cfg.fields.lastName) cfg.fields.lastName.value = last;

      // Role — try occupation, then role, then infer from registration body
      if (cfg.fields.role) {
        const candidateRole = normalizeStr(staffObj.occupation) || normalizeStr(staffObj.role) || '';
        
        if (!candidateRole || !setSelectIfValid(cfg.fields.role, candidateRole)) {
          // Infer from registration body
          if (reg) {
            const inferred = {
              'GPhC': 'pharmacist',
              'PSNI': 'pharmacist',
              'RCVS': 'veterinary_surgeon'
            }[reg.body] || '';
            if (inferred) setSelectIfValid(cfg.fields.role, inferred);
          }
        }
      }

      // Registration number
      if (cfg.fields.registrationNumber) {
        cfg.fields.registrationNumber.value = reg ? (reg.body + ' ' + reg.number) : '';
      }

      console.log('[V4P Pro Selector] setForm:', {
        first, last,
        role: cfg.fields.role ? cfg.fields.role.value : null,
        reg: cfg.fields.registrationNumber ? cfg.fields.registrationNumber.value : null
      });

      // Lock fields AFTER a frame so the browser renders the values first
      if (cfg.fields.lockOnAutoFill) {
        requestAnimationFrame(function() {
          [cfg.fields.firstName, cfg.fields.lastName, cfg.fields.registrationNumber]
            .filter(Boolean)
            .forEach(function(el) { el.readOnly = true; });

          // For <select>, don't use disabled — it breaks rendering.
          // Instead set a data attribute and block pointer events via inline style.
          if (cfg.fields.role) {
            cfg.fields.role.style.pointerEvents = 'none';
            cfg.fields.role.style.opacity = '0.7';
            cfg.fields.role.dataset.locked = 'true';
          }
        });
      }
    }

    // Helper: set select value only if a matching option exists
    function setSelectIfValid(selectEl, value) {
      const lower = value.toLowerCase();
      for (let i = 0; i < selectEl.options.length; i++) {
        if (selectEl.options[i].value.toLowerCase() === lower) {
          selectEl.selectedIndex = i;
          return true;
        }
      }
      return false;
    }

    function unlockForm() {
      [cfg.fields.firstName, cfg.fields.lastName, cfg.fields.registrationNumber]
        .filter(Boolean)
        .forEach(function(el) { el.readOnly = false; });

      if (cfg.fields.role) {
        cfg.fields.role.disabled = false;
        cfg.fields.role.style.pointerEvents = '';
        cfg.fields.role.style.opacity = '';
        cfg.fields.role.dataset.locked = '';
      }
    }

    function clearForm() {
        if (cfg.fields.firstName) cfg.fields.firstName.value = "";
        if (cfg.fields.lastName) cfg.fields.lastName.value = "";
        if (cfg.fields.role) cfg.fields.role.value = "";
        if (cfg.fields.registrationNumber) cfg.fields.registrationNumber.value = "";
        }

    function showMode(mode) {
    // If they somehow hit "current" but aren’t registered, force fallback
    if (mode === "current" && !currentIsRegistered) {
        mode = registeredStaff.length ? "select" : "manual";
        const fallbackRadio = ui.radios.find(r => r.value === mode);
        if (fallbackRadio) fallbackRadio.checked = true;
    }

    // Always unlock + clear when switching modes (prevents sticky values)
    unlockForm();
    clearForm();

    // Reset dropdown if leaving select
    if (mode !== "select") {
        ui.dropdown.value = "";
    }

    // Show/hide dropdown area
    ui.selectWrap.style.display = (mode === "select") ? "block" : "none";

    if (mode === "manual") {
        ui.hint.textContent = "Enter details manually (e.g. locum).";
        return;
    }

    if (mode === "current") {
        if (currentStaff) setForm(currentStaff);
        else clearForm(); // safety fallback
        ui.hint.textContent = "Using your registered details from your staff account.";
        return;
    }

    if (mode === "select") {
        ui.hint.textContent = "Choose a registered staff member from the list.";
        // stays unlocked until dropdown picked
        return;
    }
    }


    ui.radios.forEach(r => {
      r.addEventListener("change", () => showMode(r.value));
    });

    ui.dropdown.addEventListener("change", () => {
      const idx = parseInt(ui.dropdown.value, 10);
      if (Number.isNaN(idx)) return;
      setForm(registeredStaff[idx]);
    });

    // Default mode:
    // - if current registered => current
    // - else if registered list exists => select
    // - else => manual
    const defaultMode =
      currentIsRegistered ? "current" :
      (registeredStaff.length ? "select" : "manual");

    const defaultRadio = ui.radios.find(r => r.value === defaultMode);
    if (defaultRadio) defaultRadio.checked = true;
    showMode(defaultMode);

    return {
      session,
      registeredStaff,
      currentIsRegistered,
    };
  };
})();
